import { Component, OnInit, Renderer2, ElementRef, OnDestroy, ViewChild, Injector } from '@angular/core';
import { InputDefaultOptions } from '../../model/editor-default-options';
import { PreviewBaseEditorDirective } from './base-editor.directive';

@Component({
    selector: 'preview-editor-textbox',
    template: `
    <div [formGroup]="group" class="f-datagrid-cell-formgroup farris-group-auto">
        <input #input [attr.type]="inputType" class="form-control "
            [attr.placeholder]="options?.placeholder" [formControlName]="column.field"  maxlength="{{options?.maxLength}}">
    </div>
    `,
})
export class PreviewTextboxComponent extends PreviewBaseEditorDirective implements OnInit, OnDestroy {
    @ViewChild('input') instance: ElementRef;

    inputType = 'text';
    constructor(render: Renderer2, el: ElementRef, injector: Injector) {
        super(render, el, injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.options = Object.assign({}, InputDefaultOptions, this.options);
        this.inputElement = this.instance.nativeElement;
        if (this.options.isPassword) {
            this.inputType = 'password';
        } else {
            this.inputType = 'text';
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.instance = null;
        this.inputElement = null;
    }
}
